import React from "react";

const VidIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6204 7.52598C11.5711 8.01633 11.5711 9.31635 10.6204 9.8067L6.67525 11.8415C5.76858 12.3092 4.66675 11.6836 4.66675 10.7012L4.66675 6.63152C4.66675 5.6491 5.76859 5.02352 6.67525 5.49116L10.6204 7.52598Z"
      stroke="#6C747A"
    />
  </svg>
);

export default VidIcon;
